import React, { Component } from "react";
import { connect } from "react-redux";
import { isNullOrEmpty } from "../../../../_utils/generalUtils";
import { docPermConstants } from "../../../../_constants/permissionConstants";
import AlertModal from "../../../_common/AlertModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ccoActions from "../../../../_actions/ccoActions";

class CcoDetails extends Component {
  state = {
    showAlert_delCcoConfirm: false,
  };

  handleClick_delCco = (e) => {
    e.preventDefault();
    this.toggleAlert_delCcoConfirm();
  };

  toggleAlert_delCcoConfirm = () =>
    this.setState({ showAlert_delCcoConfirm: !this.state.showAlert_delCcoConfirm });

  handleAlert_delCcoConfirm = (action) => async () => {
    const { dispatch, ccoId, projectId, deleteCallback } = this.props;
    if (action === "accept") {
      await dispatch(ccoActions.deleteCco(ccoId, projectId));
      deleteCallback && deleteCallback();
    }
    this.toggleAlert_delCcoConfirm();
  };

  render() {
    const { showAlert_delCcoConfirm } = this.state;
    const { ccoDetails: cco, fetching, handleClick_editCco, permissions } = this.props;
    return (
      <React.Fragment>
        {cco ? (
          <h3 className="card-title mx-0">
            CO {cco.ccoNo + (!isNullOrEmpty(cco.supplementNo) && "-" + cco.supplementNo)}
          </h3>
        ) : fetching ? (
          <h5 className="text-muted">Loading...</h5>
        ) : (
          <h5 className="text-muted">No CO selected</h5>
        )}
        {cco && (
          <React.Fragment>
            <div className="row mx-0 pl-0">
              <div className="col pl-0">
                <ul className="list-group-flush border-bottom border-top mb-2 pl-0">
                  <li className="list-group-item py-1 pl-1">
                    <div className="row">
                      <div className="col pr-1">
                        <b>Description:</b>
                      </div>
                      <div className="col pl-1">{cco.description}</div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="form-row form-group">
              <button
                type="button"
                name="editCcoDetails"
                id="editCcoDetails"
                className="btn btn-secondary mr-2"
                onClick={handleClick_editCco}
                disabled={!permissions.includes(docPermConstants.EDIT_LEVEL_2)}
              >
                Edit...
              </button>
              <button
                type="button"
                name="delCco"
                id="delCco"
                className="btn btn-danger mr-2"
                onClick={this.handleClick_delCco}
                disabled={
                  !permissions.includes(docPermConstants.EDIT_LEVEL_2) || cco.hasLinks
                }
              >
                Delete
              </button>
              {cco.hasLinks && (
                <button
                  type="button"
                  name="ccoInUse"
                  id="ccoInUse"
                  className="btn btn-link text-muted p-1"
                  onClick={() => {}}
                >
                  <FontAwesomeIcon icon="lock" className="fa-fw mr-1" />
                  In Use
                </button>
              )}
            </div>
          </React.Fragment>
        )}
        {showAlert_delCcoConfirm && (
          <AlertModal
            alertTitle="Confirm Delete"
            alertTitleClass="bg-danger text-white"
            alertTitleIcon="exclamation-triangle"
            alertText="Are you sure you want to delete this change order?"
            acceptCaption="Yes"
            acceptClass="danger"
            provideReject={true}
            rejectCaption="No"
            rejectClass="secondary"
            handleAlertAction={this.handleAlert_delCcoConfirm}
            showAlertModal={showAlert_delCcoConfirm}
            toggleAlertModal={this.toggleAlert_delCcoConfirm}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  fetching: state.ccos.fetching,
  ccoDetails: state.ccos.openCcoDetails[ownProps.projectId]
    ? state.ccos.openCcoDetails[ownProps.projectId][ownProps.ccoId] || null
    : null,
});

export default connect(mapStateToProps)(CcoDetails);
